/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 *   IMPORTANT: This file is modified by the tooling
 *   script `extract-intl` It must use CommonJS module syntax
 *   import/export CANNOT be used in this file.
 */

import de from './de';
import en from './en';

const DEFAULT_LOCALE = 'en';

// prettier-ignore
const appLocales = [
  'en',
  'de',
];

const formatTranslationMessages = (locale: string, messages) => {
  const defaultFormattedMessages = locale !== DEFAULT_LOCALE ? formatTranslationMessages(DEFAULT_LOCALE, en) : {};

  const flattenFormattedMessages = (formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE ? defaultFormattedMessages[key] : messages[key];

    return { ...formattedMessages, [key]: formattedMessage };
  };

  return Object.keys(messages).reduce(flattenFormattedMessages, {});
};

const translationMessages = {
  en: formatTranslationMessages('en', en),
  de: formatTranslationMessages('de', de),
};

export { appLocales, formatTranslationMessages, translationMessages, DEFAULT_LOCALE };
